import careConfig from "@careConfig";
import { useTranslation } from "react-i18next";

export const AuthHero = () => {
  const { appName, stateLogo, customLogo } = careConfig;
  const customDescriptionHtml = __CUSTOM_DESCRIPTION_HTML__;
  const { t } = useTranslation();

  const logos = [stateLogo, customLogo].filter(
    (logo) => logo?.light || logo?.dark,
  );

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-6 md:order-first md:h-full md:w-[calc(50%+130px)] md:flex-none md:p-0 md:px-16 md:pr-[calc(4rem+130px)]">
      <div></div>
      <div className="mt-4 flex flex-col items-start rounded-lg py-4 md:mt-12">
        <div className="mb-4 hidden items-center gap-6 md:flex">
          {logos.map((logo, index) =>
            logo?.light ? (
              <img
                key={index}
                src={logo.light}
                className={`h-16 w-auto max-w-56 object-contain ${
                  index === 0 && stateLogo ? "" : "brightness-0 invert"
                }`}
                alt={
                  index === 0 && stateLogo
                    ? "State health logo"
                    : `${appName} logo`
                }
              />
            ) : null,
          )}
        </div>
        <div className="max-w-lg">
          {!customLogo?.light && (
            <h1 className="text-4xl font-black leading-tight tracking-wider text-white lg:text-5xl">
              {appName}
            </h1>
          )}
          {customDescriptionHtml ? (
            <div className="py-6">
              <div
                className="max-w-xl text-secondary-400"
                dangerouslySetInnerHTML={{
                  __html: __CUSTOM_DESCRIPTION_HTML__,
                }}
              />
            </div>
          ) : (
            <div className="max-w-xl py-6 pl-1 text-base font-semibold text-secondary-400 md:text-lg lg:text-xl">
              {t("goal")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
